import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#fff",
      "stroke-width": "2"
    }, [
      _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "11"
      }),
      _createElementVNode("path", { d: "m8 12.4286 3.1111 2.5714 4.8889-6" })
    ], -1)
  ]))]))
}
export default { render: render }